import React, { useEffect, useState } from 'react'
import { DeletedTab } from '../Components'
import { Table, TableHead, TableRow, TableCell, TableBody, TablePagination, Paper } from '@material-ui/core'
import { withRouter } from "react-router-dom";
import moment from 'moment';
import STableLoader from '../../../../shared_elements/components/skeleton_loader/STableLoader';
import { globalGetService } from '../../../../utils/globalApiServices';
import { dayMonthDateFormat, displayDateFormatShort } from '../../../../constants';
import { EmptyCollection, PageLoader } from '../../../../shared_elements';
import { checkApiStatus, Comma_format } from "../../../../utils";
const Utilization = ({ match }) => {

    const [data, setData] = useState({ list: [], pagination: {} })
    const [isLoading, setLoading] = useState(false)
    const [skeltonLoader, setSkeltonLoader] = useState(false)

    useEffect(() => {
        getDeletedListApi({ per_page: 250 }, 'skeltonLoader')
    }, [])

    const getDeletedListApi = async (query, loaderType) => {
        try {
            loaderType === "skeltonLoader" ? setSkeltonLoader(true) : setLoading(true);
            const response = await globalGetService(`/camo/util/trash/?asset=${match?.params?.asset}&asset_type=${match?.params?.assetType}`, { ...query });
            loaderType === "skeltonLoader" ? setSkeltonLoader(false) : setLoading(false);
            if (checkApiStatus(response)) {
                setData(response.data);
                return response.data;
            } else {
                throw new Error(`Failed to fetch data: ${response.status}`);
            }
        } catch (error) {
            loaderType === "skeltonLoader" ? setSkeltonLoader(false) : setLoading(false);
            console.error("Error fetching deleted list:", error);
        }
    }

    const formatDate = (date) => {
        return moment(date).format(dayMonthDateFormat);
    };
    return (
        <section className='camo-fleet-module'>
            <DeletedTab tabIndex='util' />
            {skeltonLoader ? <STableLoader count={9} size={11} /> : <>
                <Paper variant='outlined' square>
                    <div style={{ height: `${window.innerHeight - 215}px`, overflow: 'auto' }}>
                        <Table className='mui-table-format' stickyHeader={true} >
                            <TableHead>
                                <TableRow>
                                    <TableCell>Deleted By</TableCell>
                                    <TableCell>Deleted At</TableCell>
                                    <TableCell>Utilization Period</TableCell>
                                    <TableCell>TSN</TableCell>
                                    <TableCell>CSN</TableCell>
                                    <TableCell>Monthly FH</TableCell>
                                    <TableCell>Monthly FC</TableCell>
                                    <TableCell>Operating Thrust (Current)</TableCell>
                                    <TableCell>Location (A/C Reg)</TableCell>
                                    <TableCell>Location (Position)</TableCell>
                                    <TableCell>Engine Stand Location</TableCell>
                                    <TableCell>Date of Installation</TableCell>
                                    <TableCell>Date of Removal</TableCell>
                                    <TableCell>Reason of Removal</TableCell>
                                    <TableCell>Status </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data?.results?.length > 0 && data?.results.map((item, index) =>
                                    <TableRow>
                                        <TableCell> {item?.deleted_by?.name || '--'} </TableCell>
                                        <TableCell> {moment(item?.deleted_at).format(dayMonthDateFormat) || '--'} </TableCell>
                                        <TableCell style={{ minWidth: '130px' }}> {moment(item?.utilization_period).format("MMM,YYYY") || '--'}</TableCell>
                                        <TableCell>{item?.tsn > 0 || '0' ? Comma_format(item?.tsn) : '--'}</TableCell>
                                        <TableCell> {item.csn > 0 || '0' ? Comma_format(item?.csn) : '--'} </TableCell>
                                        <TableCell> {item?.monthly_FH || '--'}</TableCell>
                                        <TableCell> {item?.monthly_FC || '--'}</TableCell>
                                        <TableCell style={{ minWidth: '210px' }}> {item.current_operating_thrust ? item.current_operating_thrust?.name : "--"} </TableCell>
                                        <TableCell style={{ minWidth: '130px' }}> {item.location_reg_aircraft ? item.location_reg_aircraft : "--"}</TableCell>
                                        <TableCell style={{ minWidth: '130px' }}> {item.location_position?.label ? item.location_position?.label : "--"} </TableCell>
                                        <TableCell style={{ minWidth: '180px' }}> {item?.engine_stand_location ? item?.engine_stand_location : "--"} </TableCell>
                                        <TableCell style={{ minWidth: '190px' }}> {item.date_of_installation ? formatDate(item.date_of_installation) : "--"} </TableCell>
                                        <TableCell style={{ minWidth: '130px' }}> {item.date_of_removal ? formatDate(item.date_of_removal) : "--"} </TableCell>
                                        <TableCell style={{ minWidth: '130px' }}> {item.reason_of_removal ? item.reason_of_removal : "--"} </TableCell>
                                        <TableCell className="utilization-approval"> <span className={item?.util_approval_status?.label}>{item?.util_approval_status?.id === 4 ? "--" : item?.util_approval_status?.label || "--"}</span> <br /> <span style={{ fontSize: '11px' }}>{item?.reject_remarks || ''}</span></TableCell>
                                    </TableRow>
                                )
                                }
                            </TableBody>
                        </Table>
                        {!data?.results?.length ? <EmptyCollection title="No Records Founds" /> : null}
                    </div>
                    <TablePagination
                        rowsPerPageOptions={[100, 150, 200, 250]}
                        component="div"
                        count={data?.pagination?.total}
                        rowsPerPage={parseInt(data?.pagination?.per_page)}
                        page={data?.pagination?.current_page - 1}
                        backIconButtonProps={{ "aria-label": "previous page" }}
                        nextIconButtonProps={{ "aria-label": "next page" }}
                        onChangePage={(event, newPage) => getDeletedListApi({ per_page: data?.pagination?.per_page, page: newPage + 1 }, 'pageLoader')}
                        onChangeRowsPerPage={(event) => getDeletedListApi({ per_page: event.target.value, }, "pageLoader")}
                    /></Paper>

            </>
            }
            {isLoading ? <PageLoader /> : null}
        </section>
    )
}
export default withRouter(Utilization)